const GroupConfig = {
  endpoints: {
      list: "/group/",
      show: "/group/show/",
      showMembers: "/group/showmembers/",
      new: "/group/new",
      edit: "/group/edit",
      delete: "/group/delete/",
      leave: "/group/leave/",
      removemember: "/group/removemember/",
      getRights: "group/showrights/",
      listInvitations: "invitations/",
      quicklinks: "group/quicklinks"
    },
};


export default GroupConfig;